export default __webpack_public_path__ + "static/media/caro-nxt-icon.08615af6.svg";